// MUTATIONS
export const SET_CURRENT_USER = 'setCurrentUser';
export const SET_IS_AUTH_CHECKED = 'setIsAuthChecked';

// ACTIONS
export const ACTION_CHECK_AUTH = 'checkAuth';
export const ACTION_LOGOUT = 'logout';

// GETTERS
export const GET_CURRENT_USER = 'currentUser';
export const GET_IS_AUTH_CHECKED = 'isAuthChecked';